<template lang="pug">
  .campaign-info
    el-row
      el-col(:span="4") {{ $t('名称') }}
      el-col(:span="10") {{ data.campaignName }}
    div(
      v-for="(item,i) in data.brand"
      :key="i"
    )
      el-row
        el-col(:span="4") {{ $t('品牌类别') }}
        el-col(:span="10") {{ item.brand_category_name }}
      el-row
        el-col(:span="4") {{ $t('品牌') }}
        el-col(:span="10") {{ item.brand_name }}
    el-row
      el-col(:span="4") Bypass
      el-col(:span="10") {{ $t(data.bypass) }}
    el-row(v-show="data.IO.length !== 0")
      el-col(:span="4") {{ $t('IO号') }}
      el-col(
        :span="20"
        style="display:flex; flex-wrap: wrap"
      )
        span {{ data.IO.map(v => v.io).join(', ') }}
    el-row
      el-col(:span="4") {{ $t('预算') }}
      el-col(:span="10") {{ data.budget | formatMoney}}
    el-row
      el-col(:span="4") {{ $t('上线时间') }}
      el-col(:span="10") {{data.startDate | formatDate }} ~ {{ data.endDate | formatDate }}
    el-row
      el-col(:span="4") {{ $t('描述') }}
      el-col(:span="10") {{ data.intro || '—' }}
</template>

<script>
import { formatMoney, formatDate } from '@/umcc/util'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  filters: {
    formatMoney,
    formatDate
  }
}
</script>
